import { apiClient } from './client';

export const fetchReports = async ({ page = 1, pageSize = 20, search = '' }) => {
  const params = new URLSearchParams({ page: page.toString(), pageSize: pageSize.toString() });
  if (search) params.append('search', search);
  
  const response = await apiClient.get(`/reports?${params}`);
  return response.data;
};

export const generatePdf = async (attemptId) => {
  const response = await apiClient.post(`/reports/${attemptId}/generate`);
  return response.data;
};

export const getPdfUrl = async (attemptId) => {
  const response = await apiClient.get(`/reports/${attemptId}/download`);
  return response.data;
};

export const emailPdf = async (attemptId, email = null) => {
  const response = await apiClient.post(`/reports/${attemptId}/email`, 
    email ? { email } : {}
  );
  return response.data;
};

export const getReportsAnalytics = async () => {
  const response = await apiClient.get('/reports/analytics');
  return response.data;
};